(() => {
  if (window.veyloUpgradesReady) return;
  window.veyloUpgradesReady = true;
  const form = document.querySelector('.sky-search');
  const input = form?.querySelector('input[name="q"]');
  const results = document.querySelector('[data-vy-search-results]');
  const searchStatus = document.querySelector('[data-vy-search-status]');
  let searchTimer, searchAbort, searchSequence = 0;
  const closeSearch = () => { if (results) results.hidden = true; input?.setAttribute('aria-expanded','false'); };
  if (form && input && results) {
    const links = () => [...results.querySelectorAll('a')];
    input.addEventListener('input', () => {
      clearTimeout(searchTimer); searchAbort?.abort(); const sequence = ++searchSequence;
      const query = input.value.trim();
      if (query.length < 2) { closeSearch(); searchStatus.textContent = ''; return; }
      searchTimer = setTimeout(async () => {
        searchAbort = new AbortController();
        const url = new URL(form.dataset.predictiveUrl,location.origin);
        url.searchParams.set('q',query); url.searchParams.set('resources[type]','product');
        url.searchParams.set('resources[options][fields]','title,product_type,variants.title');
        url.searchParams.set('resources[limit]','5'); url.searchParams.set('section_id','veylo-predictive-search');
        try {
          const response = await fetch(url,{signal:searchAbort.signal});
          if (!response.ok) throw new Error('Search unavailable');
          const page = new DOMParser().parseFromString(await response.text(),'text/html');
          const content = page.querySelector('[data-vy-results]');
          if (sequence !== searchSequence || !content) return;
          results.replaceChildren(content); results.hidden = false; input.setAttribute('aria-expanded','true');
          searchStatus.textContent = form.dataset.resultsReady;
        } catch (error) { if(error.name !== 'AbortError' && sequence === searchSequence) { closeSearch(); searchStatus.textContent = form.dataset.searchError; } }
      },250);
    });
    input.addEventListener('keydown', event => {
      if(event.key === 'Escape') { searchAbort?.abort(); ++searchSequence; closeSearch(); }
      if(event.key === 'ArrowDown' && !results.hidden) { event.preventDefault(); links()[0]?.focus(); }
    });
    results.addEventListener('keydown',event => {
      const items = links(); const index = items.indexOf(document.activeElement);
      if(event.key === 'Escape') { event.preventDefault(); closeSearch(); input.focus(); }
      if(event.key === 'ArrowDown') { event.preventDefault(); items[(index+1)%items.length]?.focus(); }
      if(event.key === 'ArrowUp') { event.preventDefault(); if(index <= 0) input.focus(); else items[index-1].focus(); }
    });
    form.addEventListener('focusout',event => { if(!form.contains(event.relatedTarget)) closeSearch(); });
    document.addEventListener('click',event => { if(!form.contains(event.target)) closeSearch(); });
    form.addEventListener('submit',closeSearch);
  }
  const dialog = document.querySelector('#VeyloQuickView');
  const body = dialog?.querySelector('[data-vy-quick-body]');
  if (!dialog || !body) return;
  let opener, requestController, requestSequence = 0, priorOverflow = '';
  const close = () => dialog.close();
  dialog.querySelector('[data-vy-quick-close]').addEventListener('click',close);
  dialog.addEventListener('click',event => {
    if(event.target !== dialog) return;
    const bounds=dialog.getBoundingClientRect();
    if(event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  dialog.addEventListener('close',() => {
    requestController?.abort(); ++requestSequence;
    document.documentElement.style.overflow = priorOverflow;
    opener?.focus({preventScroll:true});
  });
  const load = async (productUrl,values,focusPosition) => {
    requestController?.abort(); requestController=new AbortController(); const sequence=++requestSequence;
    const url=new URL(productUrl,location.origin); url.searchParams.set('section_id','veylo-quick-view');
    if(values) { url.searchParams.delete('variant'); url.searchParams.set('option_values',values.join(',')); }
    dialog.setAttribute('aria-busy','true');
    body.querySelectorAll('button[type="submit"],select').forEach(node => node.disabled=true);
    try {
      const response=await fetch(url,{signal:requestController.signal});
      if(!response.ok) throw new Error('Product unavailable');
      const page=new DOMParser().parseFromString(await response.text(),'text/html');
      const content=page.querySelector('[data-vy-quick-content]');
      if(sequence !== requestSequence) return;
      if(!content) throw new Error('Product unavailable');
      body.replaceChildren(content);
      if(focusPosition) body.querySelector('[data-position="'+focusPosition+'"]')?.focus();
      else dialog.querySelector('[data-vy-quick-close]').focus();
    } catch(error) {
      if(error.name === 'AbortError' || sequence !== requestSequence) return;
      const message=document.createElement('p'); message.textContent=dialog.dataset.error;
      const link=document.createElement('a'); link.href=productUrl; link.className='sky-pill'; link.textContent=dialog.dataset.details;
      body.replaceChildren(message,link);
    } finally { if(sequence === requestSequence) dialog.removeAttribute('aria-busy'); }
  };
  document.addEventListener('click',event => {
    const link=event.target.closest('[data-vy-quick]');
    if(!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url=new URL(link.href,location.origin); if(url.origin !== location.origin) return;
    event.preventDefault(); opener=link; closeSearch();
    const loading=document.createElement('p'); loading.textContent=dialog.dataset.loading; body.replaceChildren(loading);
    priorOverflow=document.documentElement.style.overflow;
    document.documentElement.style.overflow='hidden'; dialog.showModal(); load(url.href);
  });
  body.addEventListener('change',event => {
    if(!event.target.matches('[data-vy-option]')) return;
    const content=body.querySelector('[data-vy-quick-content]');
    const values=[...body.querySelectorAll('[data-vy-option]')].map(select=>select.value);
    load(content.dataset.productUrl,values,event.target.dataset.position);
  });
})();